import React, { FC, useEffect } from 'react';

import { Board } from '@.partials';

import { storeClusterDetailStoreSelectors } from '../model/ClusterStoreDetailStore';
import { ClusterStoreModel } from '../model/ClusterStoreModel';
import S from './ClusterStoreDetail.module.scss';
import { ClusterStoreDetailHeader, ClusterStoreDetailList } from './components';

interface StoreClusterListProps {
    spCluster: ClusterStoreModel;
}

export const ClusterStoreDetail: FC<StoreClusterListProps> = ({ spCluster }) => {
    const resetState = storeClusterDetailStoreSelectors.use.resetState();
    const setSpClusterDetail = storeClusterDetailStoreSelectors.use.setSpClusterDetail();
    const fetchClusterStores = storeClusterDetailStoreSelectors.use.fetchClusterStores();

    useEffect(() => {
        const loadInitialState = async () => {
            setSpClusterDetail(spCluster);
            await fetchClusterStores();
        };

        void loadInitialState();
    }, [setSpClusterDetail, fetchClusterStores, spCluster]);

    useEffect(() => {
        return () => {
            resetState();
        };
    }, [resetState]);

    return (
        <Board.Item className={S.root}>
            <ClusterStoreDetailHeader />
            <ClusterStoreDetailList />
        </Board.Item>
    );
};
